import { Formik } from 'formik';
import { useAxios } from '../../../../context/AxiosHookContext';
import { useNotification } from '../../../../context/NotificationContext';
import { initValuesResource, validationSchemaResource } from './ResourcesFormValidator';
import CreateResourcesForm from './CreateResourcesForm';

const FormCreateResource = ({ onClose, onSuccess, valuesToEdit }) => {
    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const isEditing = valuesToEdit && Object.keys(valuesToEdit).length > 0;
    const initialValues = isEditing ? { ...initValuesResource, ...valuesToEdit } : initValuesResource;

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const payload = {
                ...values,
                publication_date: values.publication_date?.toISOString
                    ? values.publication_date.toISOString()
                    : values.publication_date,
            };

            if (isEditing) {
                await axios.put(`/app-resources/${valuesToEdit._id}`, payload);
            } else {
                await axios.post('/app-resources', payload);
            }

            showSnackbar({
                severity: 'success',
                title: 'Recursos',
                message: isEditing ? 'Recurso actualizado exitosamente.' : 'Recurso creado exitosamente.'
            });

            resetForm();
            if (onSuccess) onSuccess();
        } catch (error) {
            showSnackbar({
                severity: 'error',
                title: 'Recursos',
                message: 'Ha ocurrido un error al guardar el recurso.'
            });
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchemaResource}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            <CreateResourcesForm onClose={onClose} />
        </Formik>
    );
};

export { FormCreateResource };
export default FormCreateResource;
